const Privacy = () => {
	return (
		<>
			<h1 className="display-3 mb-4">Privacy</h1>
			<p></p>
			
		</>
	)
}
export default Privacy